export interface AppInfo {
  slug: string
  name: string
  description: string
  appStoreUrl: string
  googlePlayUrl: string
  appleAppId: string
}

export const apps: AppInfo[] = [
  {
    slug: 'purple-cow-wifi',
    name: 'Purple Cow Wi-Fi',
    description: 'Set up and manage your Purple Cow Wi-Fi network.',
    appStoreUrl: 'https://apps.apple.com/ca/app/purple-cow-wi-fi/id6748093857',
    googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.hitrontech.cloud.purplecow',
    appleAppId: '6748093857',
  },
  {
    slug: 'purple-cow-tv',
    name: 'Purple Cow TV',
    description: 'Watch your favorite channels and movies on your mobile device.',
    appStoreUrl: 'https://apps.apple.com/ca/app/purple-cow-tv/id6444726276',
    googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.espial.elevate.custom.purplecow',
    appleAppId: '6444726276',
  },
  {
    slug: 'purple-fibre',
    name: 'Purple Fibre',
    description: 'Manage your home fibre Wi-Fi network and mesh beacons.',
    appStoreUrl: 'https://apps.apple.com/ca/app/purple-fibre/id6743832959',
    googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.purplefibre.wifi',
    appleAppId: '6743832959',
  },
]
